import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

const specialPagesCollectionRN = 'contests.collections.contestsCollection';

export default function createContainer(ChildContainer) {
  class ContestViewContainer extends Component {
    constructor(props) {
      super(props);
      this.props.dataRequest();
    }

    render() {
      return <ChildContainer {...this.props} />;
    }
  }

  ContestViewContainer.propTypes = {
    // CONNECT DISPATCH
    dataRequest: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, props) => ({
    requestState: selectRequestsStateById(
      state,
      specialPagesCollectionRN,
      props.match.params.id
    ),
    item: selectItemById(state, specialPagesCollectionRN, props.match.params.id)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    dataRequest: () =>
      dispatch(dataRequest(specialPagesCollectionRN, props.match.params.id))
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContestViewContainer);
}



// WEBPACK FOOTER //
// ./src/components/Contest/containers/ContestViewContainer/ContestViewContainer.js